export default __webpack_public_path__ + "static/Image_Language-20b1745e8dd965a59d4171e526f1943f.webp";